import React from 'react';
import { connect } from 'react-redux';

import HotelRoomPreference from './HotelRoomPreference/HotelRoomPreference';

const hotelRoomPreferences = (props) => {
    return props.roomPreferences.map((roomPreference, index) => {
        let preferences = null;
        if(roomPreference.length === 1) {
            preferences = <HotelRoomPreference key={index} roomPreference={roomPreference[0]} isClubbed={false} />
        }  else {
            const rowLength = roomPreference.length;
            preferences = roomPreference.map((room, index) => <HotelRoomPreference optionCount={index + 1} key={index} roomPreference={room} isLast={rowLength === index + 1 ? true : false} isClubbed={true} />)
        }
        return preferences;
    })
}

const mapStateToProps = state => {
    return {
        roomPreferences: state.hotels.preferences
    }
}

export default connect(mapStateToProps)(hotelRoomPreferences);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelRoomPreferences/HotelRoomPreferences.js